import {
  hasCookiePermission,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage
} from "../components/layout/cookies/CookieFunctions";
import packageJson from "../../package.json";

const CACHE_KEY = "rootTranslation";
const CACHE_DURATION_HOURS = 12;

export function hasPerformanceCookiePermission(authContext) {
  return hasCookiePermission("rootTranslation", authContext);
}

export function getCachedTranslation(authContext) {
  if (!hasPerformanceCookiePermission(authContext)) {
    return null;
  }

  try {
    const cachedData = getLocalStorage(CACHE_KEY, authContext);
    if (!cachedData) {
      return null;
    }

    const parsedCache = JSON.parse(cachedData);

    if (
      !parsedCache.dateModified ||
      !parsedCache.version ||
      !parsedCache.translation
    ) {
      return null;
    }

    if (!isCacheValid(parsedCache.dateModified, parsedCache.version)) {
      removeLocalStorage(CACHE_KEY);
      return null;
    }

    return parsedCache.translation;
  } catch (error) {
    removeLocalStorage(CACHE_KEY);
    return null;
  }
}

export function setCachedTranslation(translation, authContext) {
  if (!hasPerformanceCookiePermission(authContext)) {
    return;
  }

  if (!translation) {
    return;
  }

  try {
    const cacheObject = {
      dateModified: new Date().toISOString(),
      version: packageJson.version,
      translation: translation
    };

    setLocalStorage(CACHE_KEY, JSON.stringify(cacheObject), authContext);
  } catch (error) {
    console.warn("Failed to cache translation:", error);
  }
}

function isCacheValid(dateModified, version) {
  const cacheDate = new Date(dateModified);
  const currentDate = new Date();
  const hoursDifference = (currentDate - cacheDate) / (1000 * 60 * 60);

  if (hoursDifference > CACHE_DURATION_HOURS) {
    return false;
  }

  if (version !== packageJson.version) {
    return false;
  }

  return true;
}
